import { Button, Col, Divider, Modal, Row } from 'antd';
import { Collapse, Space } from 'antd';
import React, { useState } from 'react';
import ReactJson from 'react-json-view'
const { Panel } = Collapse;

interface ILogsModalProps {
  isModalVisible: boolean
  info: ILogsModalInfo
  handleOk: ()=> void;
  handleCancel: ()=> void;
}

interface ILogsModalInfo {
  changes?: object,
  full: {
      "new info": object,
      "old info": object
  }
}

function index(props: ILogsModalProps) {
  const {info} = props
  return (
    <Modal title="Details" open={props.isModalVisible} onOk={props.handleOk} onCancel={props.handleCancel}>
      <div style={{maxHeight: 600, overflowX: 'auto', padding: '0 10px'}}>
        {info.changes && (
          <ReactJson displayDataTypes={false} name="changes" src={info.changes} />
        )}
        <ReactJson displayDataTypes={false} name="full" src={info.full} />
      </div>
    </Modal>
  )
}

export default index